import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { FIELD_TYPES } from '../../../constants';
import { TextInputFieldWUT } from '../../../ui/text-input-field';
export const TextInputWUT = props => {
  const fieldType = FIELD_TYPES.TEXT_INPUT;
  return /*#__PURE__*/React.createElement(TextInputFieldWUT, _extends({}, props, {
    fieldType: fieldType
  }));
};
//# sourceMappingURL=text-input-wut.js.map